import * as React from 'react';
const Minimize2 = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: props.size || '1em', height: props.size || '1em', viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-minimize-2", ...props },
    React.createElement("polyline", { points: "4 14 10 14 10 20" }),
    React.createElement("polyline", { points: "20 10 14 10 14 4" }),
    React.createElement("line", { x1: "14", y1: "10", x2: "21", y2: "3" }),
    React.createElement("line", { x1: "3", y1: "21", x2: "10", y2: "14" })));
export default Minimize2;
//# sourceMappingURL=Minimize2.js.map